/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FeelsMoreConfidentEnum } from './feelsMoreConfidentEnum';
import { NullEnum } from './nullEnum';
import { StudyTypeEnum } from './studyTypeEnum';
import { Tag } from './tag';
import { TeacherActivityActivityTypeEnum } from './teacherActivityActivityTypeEnum';
import { TeacherFile } from './teacherFile';

export interface TeacherActivitySnapshot { 
    readonly id: string;
    readonly created: Date;
    readonly modified: Date;
    title: string;
    activityType: TeacherActivityActivityTypeEnum;
    hourTime: number;
    dateStart: string;
    dateEnd: string;
    price?: string;
    /**
     * Zda si pedagog aktivitu platil ze svých prostředků.
     */
    selfPayer?: boolean;
    recommendToOthers?: boolean;
    studyType: StudyTypeEnum;
    organizer?: string;
    organizerWebsite?: string;
    lector?: string;
    description?: string;
    /**
     * Aktivita mi pomohla rozvíjet mé profesní kompetence.  * `strongly_agree` - Rozhodně ano * `agree` - Spíše ano * `disagree` - Spíše ne * `strongly_disagree` - Rozhodně ne
     */
    activityHelped?: FeelsMoreConfidentEnum | NullEnum;
    /**
     * Získané poznatky mohu využít v každodenní praxi.  * `strongly_agree` - Rozhodně ano * `agree` - Spíše ano * `disagree` - Spíše ne * `strongly_disagree` - Rozhodně ne
     */
    knowledgeUsage?: FeelsMoreConfidentEnum | NullEnum;
    /**
     * Odnáším si pro svou další pedagogickou praxi.
     */
    selfReflectionText?: string;
    /**
     * Během aktivity jsem narazil/a na výzvu, která mě profesně posunula.  * `strongly_agree` - Rozhodně ano * `agree` - Spíše ano * `disagree` - Spíše ne * `strongly_disagree` - Rozhodně ne
     */
    challengeExperienced?: FeelsMoreConfidentEnum | NullEnum;
    /**
     * Aktivita naplnila má očekávání.  * `strongly_agree` - Rozhodně ano * `agree` - Spíše ano * `disagree` - Spíše ne * `strongly_disagree` - Rozhodně ne
     */
    expectationsMet?: FeelsMoreConfidentEnum | NullEnum;
    /**
     * Po absolvování aktivity se cítím ve své roli pedagoga jistější.  * `strongly_agree` - Rozhodně ano * `agree` - Spíše ano * `disagree` - Spíše ne * `strongly_disagree` - Rozhodně ne
     */
    feelsMoreConfident?: FeelsMoreConfidentEnum | NullEnum;
    readonly competences: Array<Tag>;
    readonly availableCompetences: Array<Tag>;
    readonly documents: Array<TeacherFile>;
    readonly subtypeType: string;
    readonly teacherFirstName: string;
    readonly teacherLastName: string;
    readonly teacherGroups: Array<string>;
}